/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignCreatedFromTrigger = {
    BookedModal: 'booked_modal',
    MovedInModal: 'moved_in_modal',
    AutoBooked: 'auto_booked',
    ManualGrid: 'manual_grid',
    ManualFacesheet: 'manual_facesheet',
} as const;
export type EsignCreatedFromTrigger = typeof EsignCreatedFromTrigger[keyof typeof EsignCreatedFromTrigger];


export function instanceOfEsignCreatedFromTrigger(value: any): boolean {
    for (const key in EsignCreatedFromTrigger) {
        if (Object.prototype.hasOwnProperty.call(EsignCreatedFromTrigger, key)) {
            if (EsignCreatedFromTrigger[key as keyof typeof EsignCreatedFromTrigger] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignCreatedFromTriggerFromJSON(json: any): EsignCreatedFromTrigger {
    return EsignCreatedFromTriggerFromJSONTyped(json, false);
}

export function EsignCreatedFromTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignCreatedFromTrigger {
    return json as EsignCreatedFromTrigger;
}

export function EsignCreatedFromTriggerToJSON(value?: EsignCreatedFromTrigger | null): any {
    return value as any;
}

export function EsignCreatedFromTriggerToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignCreatedFromTrigger {
    return value as EsignCreatedFromTrigger;
}

